export enum Vertical {
  Base = 'base',
  WM = 'wm',
}

export enum Edition {
  SLE = 'SLE',
  WM = 'WM',
}
